import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { StepProps } from '../createStateMachine';
import { RemoteInstallFormContext } from '../index';
import css from '../index.module.scss';
import { useLang } from '@/i18n';

const Disclaimer: React.FC<StepProps<RemoteInstallFormContext>> = ({ send }) => {
    const { t } = useLang('questionnaire');

    return (
        <div className={css.step}>
            <div className="step-head">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1766458160480/pc_shp2.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1766458160670/m_shp2.jpg"
                />
                <span>{t('step_head')}</span>
            </div>
            <div className="Disclaimer-title">{t('disclaimer')}</div>
            <div className="step-btns">
                <button className="step-btn step-btn-prev" onClick={() => send('BACK')}>
                    {t('btn1')}
                </button>
                <button className="step-btn step-btn-next" onClick={() => send('next')}>
                    {t('btn2')}
                </button>
            </div>
        </div>
    );
};
export default Disclaimer;
